import React from "react";
import { Link, withRouter } from "react-router-dom";
import Accordion from "react-bootstrap/Accordion";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import moment from "moment";
import { LinkContainer } from "react-router-bootstrap";
import { Chip } from "@material-ui/core";
import { Fragment } from "react";

class Orders extends React.Component {
  constructor(props) {
    super(props);
  }
  componentDidMount() {
    this.props;
  }
  render() {
    const { orders } = this.props;
    return (
      <div className="container-fluid">
        <Accordion>
          {orders.map((order, i) => {
            const variant = i % 2 == 0 ? "info" : "secondary";
            return (
              <Card key={i}>
                <Accordion.Toggle
                  as={Button}
                  variant={
                    orders[i].shipping_source &&
                    orders[i].shipping_source.includes("Mile1")
                      ? "outline-success"
                      : variant
                  }
                  eventKey={`${orders[i].id}`}
                >
                  {orders[i].merchant.name}: {orders[i].order_number} to{" "}
                  {orders[i].shipto_first_name} {orders[i].shipto_last_name}
                  {orders[i].fulfillment_status == "partial" && (
                    <Chip
                      label={orders[i].fulfillment_status}
                      color="secondary"
                    />
                  )}
                </Accordion.Toggle>
                <Accordion.Collapse eventKey={`${orders[i].id}`}>
                  <Card.Body className="mb-2">
                    <span className="font-weight-bold">Destination:</span>{" "}
                    {orders[i].shipto_address1} {orders[i].shipto_address2},{" "}
                    {orders[i].shipto_city}, {orders[i].shipto_zip},{" "}
                    {orders[i].shipto_province}, {orders[i].shipto_country}{" "}
                    <span className="font-weight-bold">Contact:</span>{" "}
                    {orders[i].customer_phone || orders[i].email} <br></br>
                    <span className="font-weight-bold">Date:</span>{" "}
                    {moment(orders[i].created_at).format(
                      "MMMM Do YYYY, h:mm:ss a"
                    )}{" "}
                    <span className="font-weight-bold">Order Total Price:</span>{" "}
                    {orders[i].total_price} <br></br>
                    <span className="font-weight-bold">Cancelled At:</span>{" "}
                    {moment(orders[i].cancelled_at).format(
                      "MMMM Do YYYY, h:mm:ss a"
                    )}{" "}
                    {orders[i].cancelled_by ? (
                      <Fragment>
                        <span className="font-weight-bold">Cancelled By:</span>{" "}
                        {orders[i].cancelled_by}{" "}
                      </Fragment>
                    ) : (
                      <Fragment>
                        <span className="font-weight-bold">Cancel Reason:</span>{" "}
                        {orders[i].cancel_reason}{" "}
                      </Fragment>
                    )}
                    <br></br>
                    <span className="font-weight-bold">Shipping:</span>{" "}
                    {orders[i].shipping_title}{" "}
                    <span className="font-weight-bold">Paid:</span>{" "}
                    {orders[i].shipping_price}
                    <br></br>
                    <hr />
                    <span className="font-weight-bold">ITEMS:</span>{" "}
                    {/* {orders[i].line_items &&
                      orders[i].line_items.map((item) => (
                        <div key={item.id}>
                          <span className="font-weight-bold">Name:</span>{" "}
                          {item.title}{" "}
                          <span className="font-weight-bold">Sku:</span>{" "}
                          {item.sku}{" "}
                          <span className="font-weight-bold">Quantity:</span>{" "}
                          {item.quantity}{" "}
                          <span className="font-weight-bold">Price:</span>{" "}
                          {item.price}{" "}
                          <span className="font-weight-bold">Weight:</span>{" "}
                          {item.grams} grams
                        </div>
                      ))} */}
                    <br></br>
                    <LinkContainer to={`/fulfillments/${orders[i].id}`}>
                      <Button className="mr-5" variant="success">
                        Show Order
                      </Button>
                    </LinkContainer>
                    <Button variant="danger">Remove</Button>
                  </Card.Body>
                </Accordion.Collapse>
              </Card>
            );
          })}
        </Accordion>
      </div>
    );
  }
}

export default withRouter(Orders);
